import { Button, CardContent, Paper } from '@mui/material';
import { getChallenge, hideChallenge } from 'actions/challenge';
import DefaultLayout from 'layouts/default';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './index.css';
const ChallengeManagePage = () => {
  const params = useParams<{ id: string }>();
  const { enqueueSnackbar } = useSnackbar();

  const [challenge, setChallenge] = useState<any>();
  useEffect(() => {
    getChallenge(params.id).then((c) => {
      setChallenge(c);
    });
  }, [params.id]);
  if (!challenge) {
    return (
      <DefaultLayout>
        <div>Loading</div>
      </DefaultLayout>
    );
  }
  return (
    <DefaultLayout>
      <div className="ChallengeManagePage">
        <Paper>
          <CardContent>
            <Button
              className="btn"
              variant="outlined"
              onClick={() => {
                hideChallenge(params.id, !challenge.hidden)
                  .then((updatedC) => {
                    enqueueSnackbar(
                      challenge.hidden
                        ? 'Succesfully unhid the challenge. It is now viewable by everyone'
                        : 'Succesfully hid the challenge. It is now only viewable by admins',
                      {
                        variant: 'success',
                      }
                    );
                    setChallenge(updatedC);
                  })
                  .catch((err) => {
                    enqueueSnackbar(err.response.data.message, {
                      variant: 'error',
                    });
                  });
              }}
            >
              {challenge.hidden
                ? 'Make challenge public'
                : 'Archive and hide this challenge'}
            </Button>
          </CardContent>
        </Paper>
      </div>
    </DefaultLayout>
  );
};

export default ChallengeManagePage;
